<div class="p-6 flex-table-page">
  <div class="mb-6 flex justify-between items-center flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "barcode_correction_log.title" | translate }}
    </h2>
  </div>

  <app-search-form
    [searchFormat]="searchConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
  </app-search-form>

  <div class="table-section flex-table-section">
    <app-data-table
      [dataSource]="dataSource()"
      [columns]="tableColumns()"
      [loading]="loading()"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="false"
      scrollHeight="flex"
      class="w-full"
      (pageChange)="onPageChange($event)"
    >
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column.prop === "creationDate") {
          <span class="text-xs">
            {{ value ? (value | date: "dd/MM/yyyy HH:mm") : "-" }}
          </span>
        }
      </ng-template>

      <ng-template #statusTemplate let-status>
        <p-tag
          [value]="getBarcodeCorrectionStatusLabel(status) | translate"
          [severity]="getBarcodeCorrectionStatusSeverity(status)"
          styleClass="status-tag"
          [pTooltip]="getBarcodeCorrectionStatusLabel(status) | translate"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </ng-template>
    </app-data-table>
  </div>
</div>
